export const PARSE_CONFIG = {
    lastName: "personalData.lastName",
    middleNameUpsent: 'middleNameUpsent',
    firstName: "personalData.firstName",
    secondName: "personalData.middleName",
    iin: "identityData.iin",
    birthDate: "personalData.birthDate",
    sex: "personalData.sex",
    document: "identityData.identityType",
    citizenship: "personalData.citizenship",
    documentNumber: "identityData.primaryId",
    dateOfIssue: "identityData.issueDate",
    dateOfDuration: "identityData.expirationDate",
};

export const BLOCKS_CONFIG = [
    {
        name: 'nameBlock',
        fields: ['firstName', 'lastName', 'secondName'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'iinBlock',
        fields: ['iin', 'birthDate', 'sex'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'documentTypeBlock',
        fields: ['document'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'citizenshipBlock',
        fields: ['citizenship'  ],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'documentBlock',
        fields: ['documentNumber', 'dateOfIssue', 'dateOfDuration'],
        confirmed: false,
        filledCount: 0
    }

];
export const COMPARE_FIELDS = ['birthDate', 'dateOfIssue', 'dateOfDuration'];